import { FormaRecebimento } from "./enum";

export class Financa {
  idFinanca: number;
  dtVencimento: Date;
  valor: number;
  referencia: string;
  dtLancamento: Date;
  nDocReal: string;
  pg: string;
  bolnn: string;
  formaPag: number;
  condPag: number;
  chavePagamentoGateway: string;
  formaRecebimento: FormaRecebimento;
  nossoNumero: string;
  txId: string;
  descricao: string;
}
